import { render } from "./ClinicSchedule.vue?vue&type=template&id=b1179ae4&scoped=true"
import script from "./ClinicSchedule.vue?vue&type=script&lang=js"
export * from "./ClinicSchedule.vue?vue&type=script&lang=js"

import "./ClinicSchedule.vue?vue&type=style&index=0&id=b1179ae4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1179ae4"]])

export default __exports__